import { html } from "lit";
import { AnNamElement } from "../../base-element";

type UpsellItem = { title: string; url: string; price: string };

export class AnCartUpsell extends AnNamElement {
  static properties = {
    productId: { type: Number, attribute: "product-id" }
  };

  declare productId: number;
  private items: UpsellItem[] = [];

  constructor() {
    super();
    this.productId = 0;
  }

  connectedCallback(): void {
    super.connectedCallback();
    void this.loadRecommendations();
  }

  render() {
    if (!this.items.length) return html``;

    return html`
      <div class="an-upsell-wrap">
        <p class="an-upsell-heading">You may also like</p>
        <ul class="an-upsell-list">
          ${this.items.map(
            (item) => html`<li><a href="${item.url}">${item.title}</a> <span class="caption">${item.price}</span></li>`
          )}
        </ul>
      </div>
    `;
  }

  private async loadRecommendations(): Promise<void> {
    if (!this.productId) return;
    const response = await fetch(
      `/recommendations/products.json?product_id=${this.productId}&limit=3&intent=related`,
      { credentials: "same-origin" }
    );
    if (!response.ok) return;
    const payload = (await response.json()) as { products?: Array<{ title: string; url: string; price: number }> };
    this.items = (payload.products || []).map((product) => ({
      title: product.title,
      url: product.url,
      price: (product.price / 100).toLocaleString("en-AU", { style: "currency", currency: "AUD" })
    }));
    this.requestUpdate();
  }
}

if (!customElements.get("an-cart-upsell")) {
  customElements.define("an-cart-upsell", AnCartUpsell);
}
